<div id="edit-user-dialog-container" class="modal-dialog" cdkTrapFocus>
	<div class="modal-content">
		<div class="goreact-modal-header">
			<h4 class="modal-title" translate="drop-user-dialog_title"></h4>
			<button type="button" class="close-btn" (click)="cancel()" aria-label="Cancel">
				<i class="ficon-app-x"></i>
			</button>
		</div>
		<div class="goreact-modal-body">
			<p translate="drop-user-dialog_message"></p>
		</div>
		<div class="goreact-modal-footer">
			<button class="secondary-btn goreact-btn cancel-btn" (click)="cancel()" translate="common_cancel"></button>
			<button id="drop-user-dialog-close" class="primary-btn goreact-btn" (click)="close()">
				<span *ngIf="dropping$ | async as isDropping; else message" class="ficon-spinner ficon-spin"></span>
				<ng-template #message>
					<span translate="drop-user-dialog_drop"></span>
				</ng-template>
			</button>
		</div>
	</div>
</div>
